module.exports = __webpack_public_path__ + "images/emoji/beginner.8638bfbcc7fdcc9da33e.png";